import { Component, OnInit, ViewChild, HostListener, AfterViewInit } from "@angular/core";
import { HttpService } from "../shared/services/http.service";

import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { ControllerService } from "../shared/services/controller.service";

@Component({
    selector: "app-client",
    templateUrl: "./client.component.html",
    styleUrls: ["./client.component.scss"],
    standalone: false
})



export class ClientComponent implements OnInit, AfterViewInit {
  clients: any = [];
  dataSource: any;

  activeMenuId: number | null = null;
  menuTimeout: any;
  hoveredTagClientId: any = null;

  selectedTags: {id: string, tag: string}[] = []
  tagSuggestions: {id: string, tag: string}[] = []
  showTagSuggestions = false

  get selectedTagIds() {
    return this.selectedTags.map(t => t.id)
  }

  selectedClientIds: any[] = []
  selectedClientsCache: Map<string, any> = new Map()
  showBulkActionsMenu = false
  showBulkTagDialog = false
  showBulkContractDialog = false
  showBulkCodeDialog = false

  get selectedCount(): number {
    return this.selectedClientIds.length
  }

  get allSelected(): boolean {
    return this.count > 0 && this.selectedClientIds.length === this.count
  }

  get someSelected(): boolean {
    return this.selectedClientIds.length > 0 && this.selectedClientIds.length < this.count
  }

  isSelected(id: any): boolean {
    return this.selectedClientIds.includes(id)
  }

  async toggleSelectAll() {
    if (this.allSelected) {
      this.selectedClientIds = []
      this.selectedClientsCache.clear()
    } else {
      const sort = {
        active: this.sort ? this.sort.active : '',
        direction: this.sort ? this.sort.direction : ''
      }
      const res: any = await this.httpService.postAsync("hclient/listClientsPaged", {
        parents: this.parents,
        page: 0,
        size: this.count || 10000,
        filter: this.clientFilter,
        sort,
        tagIds: this.selectedTagIds
      })
      const allClients = res.data || []
      this.selectedClientIds = allClients.map((c: any) => c.id)
      this.selectedClientsCache.clear()
      allClients.forEach((c: any) => this.selectedClientsCache.set(c.id, c))
    }
  }

  toggleSelectClient(id: any) {
    if (this.selectedClientIds.includes(id)) {
      this.selectedClientIds = this.selectedClientIds.filter(i => i !== id)
      this.selectedClientsCache.delete(id)
    } else {
      this.selectedClientIds = [...this.selectedClientIds, id]
      const client = this.clients.find((c: any) => c.id === id)
      if (client) this.selectedClientsCache.set(id, client)
    }
  }

  get selectedClients(): any[] {
    return [...this.selectedClientsCache.values()]
  }

  openBulkActions(event: MouseEvent) {
    event.stopPropagation()
    this.showBulkActionsMenu = !this.showBulkActionsMenu
  }

  openBulkTagDialog() {
    this.showBulkTagDialog = true
    this.showBulkActionsMenu = false
  }

  openUpdateContract() {
    this.showBulkContractDialog = true
    this.showBulkActionsMenu = false
  }

  openBulkCodeDialog() {
    this.showBulkCodeDialog = true
    this.showBulkActionsMenu = false
  }

  // Close menu on document click
  @HostListener('document:click', ['$event'])
  onDocumentClick(_event: MouseEvent) {
    this.activeMenuId = null;
    this.showTagSuggestions = false;
    this.showBulkActionsMenu = false;
  }

  toggleMenu(id: number, event: MouseEvent) {
    event.stopPropagation();
    if (this.activeMenuId === id) {
      this.activeMenuId = null;
    } else {
      this.activeMenuId = id;
    }
  }

  onMouseLeave() {
    this.menuTimeout = setTimeout(() => {
      this.activeMenuId = null;
    }, 150);
  }

  onMouseEnter(id) {
    if (this.activeMenuId !== id) return;

    if (this.menuTimeout) {
      clearTimeout(this.menuTimeout);
      this.menuTimeout = null;
    }
  }




  filterDebounce: any

  displayedColumns: string[] = [];
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('filterInput', { static: false }) filterInput: any;

  client: any;
  bulk: Boolean =false;

  parents = false

  clientFilter = ''

  columnNames = [
    {
      id: "kind",
      value: "Type"
    },

    {
      id: "contract_start",
      value: "Start",
    },
    {
      id: "contract_end",
      value: "End",
    },
  ];

  constructor(private httpService: HttpService, private router: Router, public controller: ControllerService) {

  }

  fullClientReport( ){
    this.router.navigate(['client/_ALL_/report'])
  }

  fullActionsReport( ){
    this.router.navigate(['client/_ALL_/actions'])
  }

  monitorReport(){
    this.router.navigate(['monitor'])
  }

  onCheckboxChange(event) {
    this.parents = event.checked
    this.fetchClients()
  }

  async loadTagSuggestions(searchTerm: string) {
    const resp: any = await this.httpService.postAsync('htag/list', { searchTerm })
    const tags: {id: string, tag: string}[] = resp?.data || []
    this.tagSuggestions = tags.filter(t => !this.selectedTagIds.includes(t.id))
    this.showTagSuggestions = this.tagSuggestions.length > 0
  }

  selectTagSuggestion(tag: {id: string, tag: string}, event: MouseEvent) {
    event.stopPropagation()
    if (!this.selectedTagIds.includes(tag.id)) {
      this.selectedTags = [...this.selectedTags, tag]
    }
    this.tagSuggestions = []
    this.showTagSuggestions = false
    this.clientFilter = ''
    this.controller.setClientFilter('')
    if (this.filterInput?.nativeElement) {
      this.filterInput.nativeElement.value = ''
    }
    this.page = 0
    this.fetchClients()
  }

  removeTagFilter(tagId: string) {
    this.selectedTags = this.selectedTags.filter(t => t.id !== tagId)
    this.page = 0
    this.fetchClients()
  }

  filter(event: Event) {
    const value = (event.target as HTMLInputElement).value
    this.clientFilter = value

    if (this.filterDebounce) {
      window.clearTimeout(this.filterDebounce)
    }

    this.filterDebounce = window.setTimeout(async () => {
      const trimmed = value.trim()
      this.controller.setClientFilter(trimmed)
      this.page = 0
      const promises: Promise<any>[] = [this.fetchClients()]
      if (trimmed) {
        promises.push(this.loadTagSuggestions(trimmed))
      } else {
        this.tagSuggestions = []
        this.showTagSuggestions = false
      }
      await Promise.all(promises)
    }, 250)
  }

  closeClientDetail( event ) {
    this.client = null

    if( event ){
      this.fetchClients()
    }
  }

  bulkImport(){
    this.bulk = true
  }

  closeBulkDetail( event ){
    this.bulk = false
    if( event ){
      this.fetchClients()
    }
  }

  newClient( ){
    this.client = {'name': '', contract_start: '', contract_end: '', emails: '', school_level: '', kind:''}
  }
  editClient( clientId ){
    this.client = this.clients.find( ({id}) => id === clientId )
  }

  closeBulk (){
    this.bulk = false
  }

  getClientNameParam( clientId ){

    const client = this.clients.find( ({id}) => id === clientId )

    return this.controller.getClientNameAsParam(client.name)
  }

  gotoContent( ){
    this.router.navigate(['content/all'])
  }
  gotoUsers(){
    this.router.navigate(['client/_ALL_/user'])
  }

  gotoQuestions(){
    this.router.navigate(['feedback-questions'])
  }

  gotoReflections(clientId){
    this.router.navigate(['/shared-reflections/'], {queryParams:{clientId}})
  }

  loadCodes( clientId ){

    this.controller.setCodeFilter('')
    const name = this.getClientNameParam(clientId)
    this.router.navigate([`client/${name}/code`])
  }

  loadUsers( clientId ){
    const name = this.getClientNameParam(clientId)
    this.router.navigate([`client/${name}/user`])
  }

  loadReports( clientId ){
    const name = this.getClientNameParam(clientId)
    this.router.navigate([`client/${name}/report`])
  }

  loadActionReport( clientId ){
    const name = this.getClientNameParam(clientId)
    this.router.navigate([`client/${name}/actions`])
  }

  page = 0
  size = 10
  count = 0
  loading = false
  skeletonRows: number[][] = [];

  generateSkeletonRows() {
    this.skeletonRows = Array(10).fill(0).map(() => {
      // Random number of bars between 5 and 8 to ensure density
      const barCount = Math.floor(Math.random() * (8 - 5 + 1)) + 5;
      const bars = [];
      for (let i = 0; i < barCount; i++) {
        // Random flex weight between 1 and 10 to give variety in width
        bars.push(Math.floor(Math.random() * 10) + 1);
      }
      return bars;
    });
  }

  async fetchClients( ){
    this.loading = false
    this.generateSkeletonRows(); // Generate new random rows on fetch
    try{
      const sort = {
        active: this.sort ? this.sort.active : '',
        direction: this.sort ? this.sort.direction : ''
      }

      const res:any = await this.httpService.postAsync("hclient/listClientsPaged", {
        parents: this.parents,
        page: this.page,
        size: this.size,
        filter: this.clientFilter,
        sort,
        tagIds: this.selectedTagIds
      })

      this.clients = res.data || []
      this.count = res.count || 0

    }catch( e ){
      if( e.status == 402 ){
        this.controller.redirectToSignIn()
        return
      }
    } finally {
      this.loading = false
    }

    this.controller.setClients( this.clients )

    this.dataSource.data.length = 0
    this.dataSource.data = this.clients
  }

  async onPaginateChange(event: PageEvent) {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    await this.fetchClients();
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.page = 0
      this.fetchClients()
    })
  }

  async ngOnInit() {

    this.controller.shiftContainerToTop()

    this.controller.setPreviewing(false)
    this.displayedColumns = [
      'select',
      'kind',
      'name',
      'parent_name',
      'tag_count',
      'user_count',
      'code_count',
      'contract_start',
      'contract_end',
      'actions'
    ];
    this.dataSource = new MatTableDataSource(this.clients);
    // Remove client-side sort and paginator binding
    // this.dataSource.sort = this.sort; 
    // this.dataSource.paginator = this.paginator



    this.clientFilter = this.controller.getClientFilter()
    
    // Set the input field value explicitly to ensure it displays the stored filter
    if (this.filterInput && this.filterInput.nativeElement) {
      this.filterInput.nativeElement.value = this.clientFilter
    }
    
    // Remove client-side filtering default behavior if we are doing server-side
    // this.dataSource.filter = this.clientFilter 

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'contract_start':
        case 'contract_end': {
          var parts = item[property].split("-");
          const newDate = new Date(parts[2], parts[1] - 1, parts[0]);
          return newDate;
        }
        default: {
          return item[property];
        }
      }
    };

    await this.fetchClients()
  }

  downloadFeedback( clientId ){
    this.router.navigate(['/shared-reflections/'], {queryParams:{clientId}})
  }

  getTagCount(tags: string): number {
    if (!tags) return 0;
    return tags.split(';').map((s: string) => s.trim()).filter(Boolean).length;
  }

  getTagList(tags: string): string[] {
    if (!tags) return [];
    return tags.split(';').map((s: string) => s.trim()).filter(Boolean);
  }

  getVisibleTags(tags: string): string[] {
    return this.getTagList(tags).slice(0, 2);
  }

  getOverflowCount(tags: string): number {
    const count = this.getTagList(tags).length;
    return count > 2 ? count - 2 : 0;
  }

  getOverflowTags(tags: string): string[] {
    return this.getTagList(tags).slice(2);
  }

}
